import { history } from "../../../index";
const WithAuth = (Component: Function) => {
  const Auth = (props: object) => {
    const authenticatedUser = localStorage.getItem("token");
    if (authenticatedUser == null) {
      if (
        history.location.pathname !== "/register" &&
        history.location.pathname !== "/dashboard" &&
        history.location.pathname !== "/helper" &&
        history.location.pathname !== "/sayac-verileri" &&
        history.location.pathname !== "/tesisat-detaylari" &&
        history.location.pathname !== "/tesisat-detaylari/osf" &&
        history.location.pathname !== "/tesisat-detaylari/aylik-endex" &&
        history.location.pathname !== "/tesisat-detaylari/durum-grafikleri" &&
        history.location.pathname !== "/tesisat-detaylari/gun-bazinda-endex" &&
        history.location.pathname !== "/tesisat-detaylari/yuk-profili" &&
        history.location.pathname !== "/kullanici-islemleri"
      ) {
        // history.push('/login')
      }
    } else {
      history.push("/");
    }
    return <Component {...props} />;
  };

  return Auth;
};

export default WithAuth;
